import React from 'react';
import '../../../../../less/mobile/index.less';
import { Control } from 'MWC';
import MenuItem from '../../../../../views/menuItem.c';
import arrowMobile from '../../../../../img/new/mobile/arrow-mobile.svg'

export default function template() {

    const { active, navigate, activeSub } = this.props;
    const {
        subMenuServices,
        subMenuServices2,
        subMenuServices3
    } = this.state

    let subMenuItem = (val) => val.map((item, index) => {
        return <MenuItem
          active={active}
          alias={index.toString()}
          navigate={navigate}
          url={item.url}
          onClick={this.props.toggle}
        >
          {this.l10n(item.title)}
        </MenuItem>
      }
    )

    return (
        <div className="module-header-mobile__menu">
            <div className="module-header-mobile__menu__content">
                <Control>
                    <div className="module-header-mobile__menu__back__row">
                      <MenuItem
                          active={active}
                          alias="main"
                          navigate={navigate}
                          url="/"
                          onClick={this.props.changeMenu('main')}
                      >
                          <div className="module-header-mobile__menu__back" >
                              <img src={arrowMobile} alt="arrow back" />
                              {this.l10n('HEADER_LINK_BACK_SERVICES')}
                          </div>
                      </MenuItem>
                    </div>
                    <div className="module-header-mobile__menu__content__main__top__input">
                      <input type="text" onClick={() => window.open('/search', '_self')} placeholder={this.l10n('NEW_HEADER_INPUT_PLACEHOLDER')}/>
                    </div>
                    <div style={{marginBottom: 32}}>
                      <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_SERVICES_CLIENT_SERVICES')}</div>
                      {subMenuItem(subMenuServices)}
                    </div>
                    <div style={{marginBottom: 32}}>
                      <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_SERVICES_DOCUMENT_SERVICES')}</div>
                      {subMenuItem(subMenuServices2)}
                    </div>
                    <div>
                      <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_SERVICES_ADDITIONAL')}</div>
                      {subMenuItem(subMenuServices3)}
                    </div>
                </Control>

            </div>
        </div>
    );
}
